import { Record, Map } from "immutable";

const ZonesStateRecord = Record({
  zoneIdsBySiteId: Map(), // Map of Set
  zones: Map(),
  loading: false,
  error: null,
  selectedZoneId: ""
});

export default ZonesStateRecord;
